import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Spinner from 'components/Spinner'
import Link from 'components/Link'

import styles from './styles.css'

class Button extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    theme: PropTypes.oneOf(['primary', 'secondary']),
    size: PropTypes.oneOf(['small', 'medium', 'large', 'full']),
    rounded: PropTypes.bool,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
  }

  static defaultProps = {
    className: '',
    theme: 'primary',
    size: 'medium',
    rounded: false,
    disabled: false,
    loading: false,
  }

  getElement() {
    return 'href' in this.props ? Link : 'button'
  }

  getClassName() {
    return classnames(
      styles.root,
      styles[this.props.theme],
      styles[this.props.size],
      {
        [styles.rounded]: this.props.rounded,
        [styles.disabled]: this.props.disabled,
        [styles.loading]: this.props.loading,
      },
      this.props.className,
    )
  }

  render() {
    const {
      className,
      children,
      theme,
      size,
      rounded,
      loading,

      ...restProps
    } = this.props

    const Element = this.getElement()

    return (
      <Element
        {...restProps}
        disabled={this.props.disabled || this.props.loading}
        className={this.getClassName()}
      >
        {loading && (
          <span className={styles.spinnerWrapper}>
            <Spinner width="30" height="30" color="#fff" />
          </span>
        )}

        <span className={styles.content}>{children}</span>
      </Element>
    )
  }
}

export default Button



// WEBPACK FOOTER //
// ../source/components/Button/index.js